"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from "@dc/ui/components";
import { useTranslations } from "next-intl";
type TrimbleTrialRedirectLoaderProps = {
  error: boolean;
  onRetry: () => void;
};
export function TrimbleTrialRedirectLoader(t0) {
  const $ = _c(22);
  const {
    error,
    onRetry
  } = t0;
  const t = useTranslations("trials.public_signup_trimble_redirect");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Spinner size="lg" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h1 className="font-semibold text-2xl leading-tight md:text-3xl">{t2}</h1>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("body");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="max-w-sm text-muted-foreground text-sm">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("terms");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="rounded-lg bg-default-100 px-4 py-3 text-default-600 text-sm">{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== error || $[14] !== onRetry || $[15] !== t) {
    t8 = error ? <div className="flex flex-col items-center gap-3"><p className="text-danger-500 text-sm">{t("error")}</p><Button color="primary" onPress={onRetry}>{t("try_again")}</Button></div> : null;
    $[13] = error;
    $[14] = onRetry;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div aria-live="polite" className="flex flex-col items-center gap-4 text-center">{t1}{t3}{t5}{t7}{t8}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}